module.exports = __webpack_public_path__ + "static/media/juan_duque.b44c3b40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/juan_duque.png
// module id = 1167
// module chunks = 0